module.exports = __webpack_public_path__ + "img/mean1.b6ca1c65.png";